<template>
  <layout-view navTitle="Фильтры">
    <template v-slot:nav>
      <portal to="back">
        <v-btn icon @click="$router.push('../')">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </portal>
      <div class="px-4">
        <date-interval name="Дата визита" :valueFrom.sync="filter.dateFrom" :valueTo.sync="filter.dateTo" />

        <date-interval name="Дата создания визита" :valueFrom.sync="filter.createDateFrom" :valueTo.sync="filter.createDateTo" />

        <user-autocomplete-multiple name="Клиенты" :select.sync="filter.usersClientSelected"/>

        <user-autocomplete-multiple name="Специалисты" _type="spec" :select.sync="filter.usersSpecSelected"/>

        <user-autocomplete-multiple name="Направляющие" :select.sync="filter.referralsSelected"/>

        <com-branch-autocomplete-multiple :select.sync="filter.comBranchsSelected" globalState/>
   
        <v-autocomplete
            v-model="filter.visitStatusSelected"
            :items="visitStatuses"
            :search-input.sync="visitStatusText"
            label="Статус"
            outlined
            dense
            hide-details="auto"
            multiple
            class="mb-4"
            item-text="name"
            item-value="id"
        >
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Не найдено</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-slot:item="{item}">
            <v-list-item-title>
              <div class="py-2">
                <v-avatar :color="item.color" size="12" class="mr-2"/>{{item.name}}
              </div>
            </v-list-item-title>
          </template>
          <template v-slot:selection="{item}">
            <v-chip class="full-width mt-2" small style="width:95%">
              <v-row no-gutters>
                <v-col cols="auto"><v-avatar :color="item.color" class="circleIcon mr-2"/></v-col>
                <v-col class="text-overflow">{{item.name}}</v-col>
                <v-col cols="auto"><v-icon small @click.stop="visitStatusSelected=visitStatusSelected.filter((v)=>v!==item.id)">mdi-close-circle</v-icon></v-col>
              </v-row>
            </v-chip>
          </template>
        </v-autocomplete>

      </div>
    </template>
    <template v-slot:content="{height}">
      <n-table-view
        ref="table"
        name="Список"
        :genRequestBuilder="genRequestBuilder"
        :height="height"
        :headers="[
            { text: 'Статус', value:'status', sortable: true},
            { text: 'ID', value:'id', sortable: true},
            { text: 'Номер карты', value:'user.userProfile.medCardNumber', sortable: true},
            { text: 'Кто', value:'user.lastName', sortable: true},
            { text: 'Телефон', value:'user.phone', sortable: true},
            { text: 'К кому', value:'userSpec.user.lastName', sortable: true},
            { text: 'Специальность', value:'userSpec.spec.name', sortable: true},
            { text: 'Направляющий', value:'referral.lastName', sortable: true},
            { text: 'Кабинет', value:'comPlace.comRoom.sid', sortable: true},
            { text: 'Оплачено',  class:'text-no-wrap', sortable:false},
            { text: 'Осталось',  class:'text-no-wrap', sortable:false},
            { text: 'Дата и время', value:'begin', sortable: true},
            { text: 'Создано', value:'created', sortable: true},
          ]"
      >
    
      <template v-slot:item="{ item }">
          <tr v-if="!!item.user" @click="visitId=item.id;">
            <td class="text-no-wrap">
              <visit-status :status="$tools.findById(visitStatuses, item.status)" :isPaidFull="item.paySummary.isPaidFull" :isSecond="item.isSecond" small/>
            </td>
            <td>{{ item.user.id }}</td>
            <td v-if="item.user.userProfile.medCardNumber">{{item.user.userProfile.medCardNumber}}</td>
            <td v-else>{{item.user.id}}</td>
            <td class="text-no-wrap">
              <UserFullName :user="item.user"/>
            </td>
            <td class="text-no-wrap">
                <call-phone :phone="item.user.phone" />
            </td>
            <td class="text-no-wrap">
              <UserFullName :user="item.userSpec.user" type="spec" avatar/>
            </td>
            <td class="text-no-wrap">
              {{ item.userSpec.spec.name }}
            </td>
            <td class="text-no-wrap" @click.stop>
              <visit-referrer :visitId="item.id" :referrer="item.referral" @delete="$refs.table.load()" @created="$refs.table.load()" @update="$refs.table.load()" compact/>
            </td>
            <td class="text-no-wrap">
              <ComBranchTooltip :comBranch="item.comPlace.comRoom.comFloor.comBuilding.comBranch"/> / {{ item.comPlace.comRoom.sid }}
            </td>
            <td class="text-no-wrap text-right">{{item.paySummary.success.toFixed(2)}} Р</td>
            <td class="text-no-wrap text-right">{{item.paySummary.wait.toFixed(2)}} Р</td>
            <td class="text-no-wrap">{{$tools.dateTimeFormat(item.begin, 'DD.MM.YYYY HH:mm' )}}</td>
            <td class="text-no-wrap">{{$tools.dateTimeFormat(item.created, 'DD.MM.YYYY HH:mm' )}}</td>
          </tr>
        </template>
      </n-table-view>
      
      <visit :visitId.sync="visitId" @reLoadTable="$refs.table.load()"/>
    </template>
  </layout-view>
</template>

<script>
import Api from "@/Api";
import LayoutView from "@/components/LayoutView";
import NTableView from "@/componentsV2/base/NTableView.vue";
// import LabelView from "@/components/LabelView";
import moment from "moment";
import DateInterval from "@/componentsV2/base/DateInterval.vue";
import ComBranchAutocompleteMultiple from "@/componentsV2/custom/ComBranchAutocompleteMultiple.vue";
import UserAutocompleteMultiple from "@/componentsV2/custom/UserAutocompleteMultiple.vue";
import VisitStatus from "@/components/VisitStatus";
import CallPhone from "@/components/CallPhone";
import Visit from "@/views/Visit/Visit";
import VisitReferrer from "@/views/Visit/VisitReferrer";
import ComBranchTooltip from "@/componentsV2/custom/ComBranchTooltip.vue";
import UserFullName from "@/componentsV2/custom/UserFullName.vue";

import {
  Entity_Visit, 
  Entity_User, 
  Entity_UserSpec, 
  Entity_UserProfile, 
  Entity_Spec,   
  Entity_ComPlace,
  Entity_ComRoom,
  Entity_ComFloor,
  Entity_ComBuilding,
  Entity_Referral,
  Entity_ComBranch} from "../../../EntityStoreCacheService";



export default {
  components: {
    NTableView,
    LayoutView,
    DateInterval,
    UserAutocompleteMultiple,
    ComBranchAutocompleteMultiple,
    VisitStatus,
    CallPhone,
    Visit,
    VisitReferrer,
    ComBranchTooltip,
    UserFullName
  },

  data:()=>({
    filter: {
      dateFrom:null,
      dateTo:null,
      createDateFrom:null,
      createDateTo:null,
      comBranchsSelected: [],
      visitStatusSelected:[],
      usersClientSelected:[],
      usersSpecSelected:[],
      referralsSelected: [],
    },

    visitStatuses:Api.model.Visit.statuses,
    visitStatusText:null,
    visitId:null,
  }),
  watch:{
    filter: {
      deep: true,
      handler () {
        this.$refs.table.load();
      },
    },
  },
  methods:{
    genRequestBuilder(page, onPage, sortFields){
      let rb = new Entity_Visit()
        .selects(Entity_Visit.id)
        .selects(Entity_Visit.begin)
        .selects(Entity_Visit.comment)
        .selects(Entity_Visit.created)
        .selects(Entity_Visit.end)
        .selects(Entity_Visit.isSecond)
        .selects(Entity_Visit.mark)
        .selects(Entity_Visit.status)

       
        //user
        .selects([Entity_Visit.user, Entity_User.id].join('.'))
        .selects([Entity_Visit.user, Entity_User.firstName].join('.'))
        .selects([Entity_Visit.user, Entity_User.lastName].join('.'))
        .selects([Entity_Visit.user, Entity_User.secondName].join('.'))
        .selects([Entity_Visit.user, Entity_User.phone].join('.'))
        .selects([Entity_Visit.user, Entity_User.userProfile, Entity_UserProfile.medCardNumber].join('.'))
  

        //userSpec
        .selects([Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.id].join('.'))
        .selects([Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.firstName].join('.'))
        .selects([Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.lastName].join('.'))
        .selects([Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.secondName].join('.'))
        .selects([Entity_Visit.userSpec, Entity_UserSpec.spec, Entity_Spec.name].join('.'))
        .selects([Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.imageUrl].join('.'))

        //referral
        .selects([Entity_Visit.referral, Entity_Referral.id].join('.'))
        .selects([Entity_Visit.referral, Entity_Referral.comment].join('.'))
        .selects([Entity_Visit.referral, Entity_Referral.phone].join('.'))
        .selects([Entity_Visit.referral, Entity_Referral.name].join('.'))
        .selects([Entity_Visit.referral, Entity_Referral.status].join('.'))

        //user
        .selects([Entity_Visit.referral, Entity_Referral.user, Entity_User.id].join('.'))
        .selects([Entity_Visit.referral, Entity_Referral.user, Entity_User.firstName].join('.'))
        .selects([Entity_Visit.referral, Entity_Referral.user, Entity_User.lastName].join('.'))
        .selects([Entity_Visit.referral, Entity_Referral.user, Entity_User.secondName].join('.'))
        .selects([Entity_Visit.referral, Entity_Referral.user, Entity_User.phone].join('.'))

        //comPlace
        .selects([Entity_Visit.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.sid].join('.'))

        //comBranch
        .selects([Entity_Visit.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.comFloor, Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch, Entity_ComBranch.id].join('.'))
        .selects([Entity_Visit.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.comFloor, Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch, Entity_ComBranch.name].join('.'))
        .selects([Entity_Visit.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.comFloor, Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch, Entity_ComBranch.color].join('.'))
       
        //virtual
        .virtual(Entity_Visit.virtual_paySummary);

        rb.page(page).onPage(onPage)

        //filters

        //by combranch
        if(this.filter.comBranchsSelected.length>0){          
          rb.filterAnd([Entity_Visit.entity, Entity_Visit.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.comFloor, Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch, Entity_ComBranch.id].join('.')+' in (?)',this.filter.comBranchsSelected.map(i=>i.id));
        }

        //by date
        if(this.filter.dateFrom) {  
          rb.filterAnd([Entity_Visit.entity, Entity_Visit.begin].join('.')+'>=?',moment(this.filter.dateFrom, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00'));
        } 

        if(this.filter.dateTo) {  
          rb.filterAnd([Entity_Visit.entity, Entity_Visit.begin].join('.')+'<=?',moment(this.filter.dateTo, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59'));
        }

        // by created date
        if(this.filter.createDateFrom) {  
          rb.filterAnd([Entity_Visit.entity, Entity_Visit.created].join('.')+'>=?',moment(this.filter.createDateFrom, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00'));
        } 

        if(this.filter.createDateTo) {  
          rb.filterAnd([Entity_Visit.entity, Entity_Visit.created].join('.')+'<=?',moment(this.filter.createDateTo, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59'));
        }

         //by user client
        if (this.filter.usersClientSelected.length>0) {
          rb.filterAnd([Entity_Visit.entity, Entity_User.entity, Entity_User.id].join('.')+' in (?)', this.filter.usersClientSelected.map(i=>i.id))
        }

        //by userSpec
        if (this.filter.usersSpecSelected.length>0) {
          rb.filterAnd([Entity_Visit.entity, Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.id].join('.')+' in (?)',this.filter.usersSpecSelected.map(i=>i.id))
        }

        //by referrals
        if (this.filter.referralsSelected.length>0) {
          rb.filterAnd([Entity_Visit.entity, Entity_Visit.referral, Entity_User.id].join('.')+' in (?)', this.filter.referralsSelected.map(i=>i.id))
        }

        //by status
        if (this.filter.visitStatusSelected.length>0) {
          rb.filterAnd([Entity_Visit.entity, Entity_Visit.status].join('.')+' in (?)', this.filter.visitStatusSelected)
        }
    
        sortFields.forEach(v=>{
          rb.order(v.field, v.isAsc)
        })

        return rb;
    }
  }
}
</script>